import { useCallback } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { AIQuota } from "@graylog/enterprise-api";
import UserNotification from "util/UserNotification";
import { onError } from "util/conditional/onError";
export const INVESTIGATION_AI_REPORT_QUOTA_STATUS = "investigation_ai_report_quota_status";
export const useInvalidateAIQuotaStatus = () => {
  const queryClient = useQueryClient();
  return useCallback(
    () => queryClient.invalidateQueries({ queryKey: [INVESTIGATION_AI_REPORT_QUOTA_STATUS] }),
    [queryClient]
  );
};
export const useAIQuotaStatus = () => {
  const { data, isFetching, isLoading, isError, refetch } = useQuery({
    queryKey: [INVESTIGATION_AI_REPORT_QUOTA_STATUS],
    queryFn: () => onError(AIQuota.quotaStatus(), (errorThrown) => {
      if (!(errorThrown.status === 404)) {
        UserNotification.error(`Loading AI Report quota status failed with: ${errorThrown}`);
      }
    })
  });
  return {
    data,
    isFetching,
    isLoading,
    isError,
    refetch
  };
};
export default useAIQuotaStatus;
